import React, { useState } from "react";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import dayjs, { Dayjs } from "dayjs";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import IconButton from "@mui/material/IconButton";
import Popper from "@mui/material/Popper";

interface CalendarIconTriggerProps {
  currentDate: Date;
  setCurrentDate: (date: Date) => void;
}

export const CalendarIconTrigger: React.FC<CalendarIconTriggerProps> = ({
  currentDate,
  setCurrentDate,
}) => {
  const [open, setOpen] = useState(false);
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null); // ✅ Fixes the anchorEl type

  return (
    <div className="datepicker-wrap">
      <IconButton
        aria-label="Open date picker"
        onClick={(e) => {
          setAnchorEl(e.currentTarget); // ✅ Now correctly typed
          setOpen((prev) => !prev);
        }}
        size="small"
        sx={{
          backgroundColor: "#fff",
          borderRadius: "8px",
          padding: "6px",
        }}
      >
        <CalendarTodayIcon sx={{ color: "#2563eb" }} />
      </IconButton>

      <Popper open={open} anchorEl={anchorEl} placement="bottom-start">
        <DatePicker
          open
          disableOpenPicker
          value={dayjs(currentDate)}
          onClose={() => setOpen(false)}
          onChange={(newDate: Dayjs | null) => {
            if (newDate) {
              setCurrentDate(newDate.toDate());
              setOpen(false);
            }
          }}
          slotProps={{
            textField: { style: { display: "none" } }, // ✅ Hides input
          }}
        />
      </Popper>
    </div>
  );
};
